import { Component, OnDestroy, OnInit } from "@angular/core";
import { Contract } from "@edp-components/edp-contract";
import { ConsumptionWithDisaggregation, SmartNowConsumptionsValues, SmartNowStatus } from "@edp-models/smart-now.model";
import { getContract } from "@edp-store/selectors/contract.selectors";
import { getConsumptionWithDesaggregation, getPrediction, getSmartNowStatus } from "@edp-store/selectors/smart-now.selector";
import { IAppState } from "@edp-store/state/app.state";
import { select, Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import moment from "moment";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "edp-smartnow-dashboard-widget",
    templateUrl: "./edp-smartnow-dashboard-widget.component.html",
    styleUrls: ["./edp-smartnow-dashboard-widget.component.scss"],
})
export class EdpSmartnowDashboardWidgetComponent implements OnDestroy, OnInit {
    unsubscribe$ = new Subject();
    consumption: ConsumptionWithDisaggregation;
    prediction: SmartNowConsumptionsValues;
    private timeLastCommunication: string;
    public contract: Contract;

    constructor(private readonly store: Store<IAppState>, private translate: TranslateService) {
        this.store.pipe(takeUntil(this.unsubscribe$), select(getConsumptionWithDesaggregation)).subscribe(consumption => {
            if (consumption) {
                this.consumption = consumption[0];
            }
        });
        this.store.pipe(takeUntil(this.unsubscribe$), select(getPrediction)).subscribe(prediction => (this.prediction = prediction));

        this.store.pipe(takeUntil(this.unsubscribe$), select(getContract)).subscribe(contract => (this.contract = contract));
    }

    ngOnInit() {
        this.getSmartnowStatus();
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    private getSmartnowStatus() {
        this.store.pipe(takeUntil(this.unsubscribe$), select(getSmartNowStatus)).subscribe((status: SmartNowStatus) => {
            if (!!status) {
                if (!status.status) {
                    const date = moment(status.lastCommunication).utc();
                    const diff = moment.duration(moment().utc().diff(date));
                    if (diff.asMinutes() >= 30) {

                        if (diff.asMinutes() < 60) {
                            this.timeLastCommunication = Math.floor(diff.asMinutes()) + " "
                                + this.translate.instant("pt.edp.edponline.consumptions.smartnow.offline.minutes");
                        } else {
                            this.timeLastCommunication = (diff.asHours() < 24)
                                ? Math.floor(diff.asHours()) + " "
                                    + this.translate.instant("pt.edp.edponline.consumptions.smartnow.offline.hours")
                                : Math.floor(diff.asDays()) + " "
                                    + this.translate.instant("pt.edp.edponline.consumptions.smartnow.offline.days");
                        }
                    }
                }

            }

        });
    }

    get offlineTime() {
        return this.timeLastCommunication;
    }
}
